import BoldText from '@/components/BoldText';
import RegularText from '@/components/RegularText';
import { THUMBNAIL } from '@/helpers/link';
import { BlockStack, Box, Button } from '@shopify/polaris';
import { ChevronRightIcon } from '@shopify/polaris-icons';
import { useTranslation } from 'react-i18next';
import { ButtonStyled, StyledBox } from './styled';
import { useNavigate } from 'react-router-dom';
import { PATH } from '@/constants/path';

const WidgetPreviewEmpty = () => {
  const { t } = useTranslation('widget_settings');
  const navigate = useNavigate();

  return (
    <StyledBox>
      <Box background="bg-surface" paddingInline={'300'} minHeight="420px" minWidth="325px">
        <BlockStack align="center" inlineAlign="center" gap={'200'}>
          <img src={THUMBNAIL.EMPTY_METHOD_IMG} alt="" />
          <BoldText>{t('widgetDesign.emptyMethod.title')}</BoldText>
          <Box paddingBlockEnd={'400'}>
            <RegularText alignment="center" tone="subdued">
              {t('widgetDesign.emptyMethod.desc')}
            </RegularText>
            <RegularText alignment="center" tone="subdued">
              {t('widgetDesign.emptyMethod.subDesc')}
            </RegularText>
          </Box>
          <ButtonStyled>
            <Button icon={ChevronRightIcon} onClick={() => navigate(PATH.SHIPPING)} variant="primary">
              {t('widgetDesign.emptyMethod.activeShipping')}
            </Button>
          </ButtonStyled>
          <RegularText>{t('widgetDesign.emptyMethod.or')}</RegularText>
          <ButtonStyled>
            <Button icon={ChevronRightIcon} onClick={() => navigate(PATH.LOCATIONS)}>
              {t('widgetDesign.emptyMethod.activePickupDelivery')}
            </Button>
          </ButtonStyled>
        </BlockStack>
      </Box>
    </StyledBox>
  );
};

export default WidgetPreviewEmpty;
